module.exports = __webpack_public_path__ + "img/geschenkt-top.9a087c91.jpeg";